// Dependencias
import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import {createRoot} from 'react-dom/client';
import * as Llamadas from './Llamadas';

const PrecioHoteles = () => {
  const PrecioHoteles = useRef();

  return (
    <div></div>
  )
};

class WebComponent extends HTMLElement {
	constructor() {
		super();
	}

	async connectedCallback() {
	
		var hotel = true;
		
		var urlRoiback = await Llamadas.getConfiguracion("url-roiback-" + Liferay.ThemeDisplay.getLanguageId());
		
		//EXPERIENCIAS
		var elementosCard = document.querySelectorAll("div.experiences-hoteles-container div.viva-hotel-card");
		for(i = 0; i < elementosCard.length; i++) {
			var elementosPrecio = elementosCard[i].querySelector("#priceHotel");
			var elementoCodHotel = elementosCard[i].querySelector("#codHotel");
			var elementosBoton = elementosCard[i].querySelector("#botonReservarHotel");
			
			var precioHotel = await Llamadas.getPrecioHotel(elementoCodHotel.innerHTML);
			
			if(precioHotel && precioHotel.price && precioHotel.price != 0) {
				hotel = false;
				var precioNoche = precioHotel.price / precioHotel.lengthOfStay;
				elementosPrecio.innerHTML = precioNoche.toFixed(0) + " " + precioHotel.currency;
				
				var fechaEntrada = new Date(precioHotel.checkIn);
				var fechaSalida = new Date(fechaEntrada);
				if(elementoCodHotel.innerHTML == "vanityhotel") {
					fechaSalida.setDate(fechaSalida.getDate() + 1);
				} else {
					fechaSalida.setDate(fechaSalida.getDate() + 2);
				}
				
				elementosBoton.href = urlRoiback + "/bookcore/availability/" + elementoCodHotel.innerHTML + "/" + precioHotel.checkIn + "/" + 
						fechaSalida.getFullYear() + "-" + ((fechaSalida.getMonth() + 1 < 10) ? "0" + (fechaSalida.getMonth() + 1) : fechaSalida.getMonth() + 1) + "-" + ((fechaSalida.getDate() < 10) ? "0" + fechaSalida.getDate() : fechaSalida.getDate()) +
						"?adults=2";
			}
		}
		
		//PARTNERS
		var elementosCard = document.querySelectorAll("section.hotel-info-list div.new_cardsPartners.card");
		for(i = 0; i < elementosCard.length; i++) {
			var elementosPrecio = elementosCard[i].querySelector("#priceHotel");
			var elementoCodHotel = elementosCard[i].querySelector("#codHotel");
			
			var precioHotel = await Llamadas.getPrecioHotel(elementoCodHotel.innerHTML);
			
			if(precioHotel && precioHotel.price && precioHotel.price != 0) {
				hotel = false;
				var precioNoche = precioHotel.price / precioHotel.lengthOfStay;
				elementosPrecio.innerHTML = precioNoche.toFixed(0) + " " + precioHotel.currency;
			}
		}
		
		//GALERIA
		var elementosCard = document.querySelectorAll(".hotel-gallery-btn-back");
		for(i = 0; i < elementosCard.length; i++) {
			var elementosPrecio = elementosCard[i].querySelector("#priceHotel");
			var elementoCodHotel = document.querySelector("#codHotel");
			var elementosBoton = elementosCard[i].querySelector("#btnModal");
			
			var precioHotel = await Llamadas.getPrecioHotel(elementoCodHotel.innerHTML);
			
			if(precioHotel && precioHotel.price && precioHotel.price != 0 && elementosPrecio) {
				hotel = false;
				var precioNoche = precioHotel.price / precioHotel.lengthOfStay;
				elementosPrecio.innerHTML = precioNoche.toFixed(0) + " " + precioHotel.currency;
				
				var fechaEntrada = new Date(precioHotel.checkIn);
				var fechaSalida = new Date(fechaEntrada);
				if(elementoCodHotel.innerHTML == "vanityhotel") {
					fechaSalida.setDate(fechaSalida.getDate() + 1);
				} else {
					fechaSalida.setDate(fechaSalida.getDate() + 2);
				}
				
				elementosBoton.href = urlRoiback + "/bookcore/availability/" + elementoCodHotel.innerHTML + "/" + precioHotel.checkIn + "/" + 
						fechaSalida.getFullYear() + "-" + ((fechaSalida.getMonth() + 1 < 10) ? "0" + (fechaSalida.getMonth() + 1) : fechaSalida.getMonth() + 1) + "-" + ((fechaSalida.getDate() < 10) ? "0" + fechaSalida.getDate() : fechaSalida.getDate()) +
						"?adults=2";
			}
		}
		
		//HOTEL
		if(hotel) {
			var elementosPrecio = document.getElementById("priceHotel");
			var elementosBoton = document.getElementById("botonReservarHotel");
			var elementoCodHotel = document.getElementById("codHotel");
			var precioHotel = await Llamadas.getPrecioHotel(elementoCodHotel.innerHTML);
			
			if(precioHotel && precioHotel.price && precioHotel.price != 0) {
				var precioNoche = precioHotel.price / precioHotel.lengthOfStay;
				elementosPrecio.innerHTML = precioNoche.toFixed(0) + " " + precioHotel.currency;
				
				var fechaEntrada = new Date(precioHotel.checkIn);
				var fechaSalida = new Date(fechaEntrada);
				if(elementoCodHotel.innerHTML == "vanityhotel") {
					fechaSalida.setDate(fechaSalida.getDate() + 1);
				} else {
					fechaSalida.setDate(fechaSalida.getDate() + 2);
				}
				
				elementosBoton.href = urlRoiback + "/bookcore/availability/" + elementoCodHotel.innerHTML + "/" + precioHotel.checkIn + "/" + 
						fechaSalida.getFullYear() + "-" + ((fechaSalida.getMonth() + 1 < 10) ? "0" + (fechaSalida.getMonth() + 1) : fechaSalida.getMonth() + 1) + "-" + ((fechaSalida.getDate() < 10) ? "0" + fechaSalida.getDate() : fechaSalida.getDate()) +
						"?adults=2";
			}
		}
		
				createRoot(this).render(
					<PrecioHoteles
					/>,
					this
				);
	}
}

const ELEMENT_ID = 'liferay-hoteles-viva-precio-hoteles';

if (!customElements.get(ELEMENT_ID)) {
	customElements.define(ELEMENT_ID, WebComponent);
}
